import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OnboardingLayout } from '../Layout';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { useSubscriptionPlans } from '@/api/queries/subscription';
import { useAutoBookingStatus } from '@/api/queries/user';
import { paths } from '@/routes/paths';
import { centsToUsdString } from '@/utils/money';
import { useLocale } from '@/hooks/useLocale';

export function OnboardingSubscribePitchPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const plans = useSubscriptionPlans(true);
  const abs = useAutoBookingStatus();
  const { locale } = useLocale();

  const plan = plans.data?.[0];
  const minBalance = centsToUsdString(abs.data?.min_balance_cents ?? 1_000_000, locale);

  return (
    <OnboardingLayout back title={t('onboarding.subscribe.title')}>
      <Card variant="light" padding="lg">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={{ margin: 0, lineHeight: 1.5 }}>
            {t('onboarding.subscribe.body', { minBalance })}
          </p>
          {plans.isLoading ? (
            <Spinner />
          ) : plan ? (
            <>
              <p style={{ margin: 0, fontWeight: 600 }}>
                {plan.period === 'annual'
                  ? t('onboarding.subscribe.yearly_price', {
                      price: centsToUsdString(plan.amount_cents, locale),
                    })
                  : t('onboarding.subscribe.monthly_price', {
                      price: centsToUsdString(plan.amount_cents, locale),
                    })}
              </p>
              <Button
                block
                size="lg"
                variant="primary"
                onClick={() => navigate(paths.subscribePayment(plan.code))}
              >
                {t('onboarding.subscribe.subscribe')}
              </Button>
            </>
          ) : null}
        </div>
      </Card>
      <Button
        block
        size="lg"
        variant="ghost"
        onClick={() => navigate(paths.onboardingAllSet)}
      >
        {t('onboarding.subscribe.skip_for_now')}
      </Button>
    </OnboardingLayout>
  );
}
